import { type Accept, ErrorCode, type FileRejection } from 'react-dropzone'

import type { FileDropzoneItem } from '@/modules/upload/types'
import { formatTypeRestriction } from './hint'

export const isFileRejection = (
  item: FileDropzoneItem,
): item is FileRejection => 'errors' in item

export const hasInvalidType = (rejections: FileRejection[]) =>
  rejections.some(({ errors }) =>
    errors.some((error) => error.code === ErrorCode.FileInvalidType),
  )

export const describeRejection = (
  rejection: FileRejection,
  accept?: Accept,
  maxSize?: number,
) => {
  const [error] = rejection.errors
  if (error?.code === ErrorCode.FileInvalidType) {
    return `${formatTypeRestriction(accept)}.`
  }
  if (error?.code === ErrorCode.FileTooLarge) {
    return maxSize
      ? `Size limit of ${maxSize} MB exceeded.`
      : 'File is too large.'
  }
  return error?.message ?? "This file can't be uploaded."
}
